<template>
  <div>
    <div :class="$route.params.tourId ? 'container-fluid' : 'container'">
      <legend>Долг</legend>
      <debt-by-tour-id
          :allow-printing="true"
          v-if="$route.params.tourId"
      ></debt-by-tour-id>
      <table class="table table-bordered table-hover table-sm" v-else>
        <thead>
        <tr>
          <th>Объезд</th>
          <th width="130">Количество</th>
          <th width="80" v-for="pt in $root.paymentTypes">{{pt.Name}}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>Все объезды</td>
          <td>{{totalOrderCount}}</td>
          <td v-for="pt in $root.paymentTypes">{{totalSummaryByPtId(pt.Id) || ''}}</td>
          <!--                    <td>{{totalSummary}}</td>-->
        </tr>
        <tr v-for="stat in tourStats">
          <td>
            <router-link
                :to="{ name: 'debt', params: {tourId: stat['Tour.Id']}}">
              {{stat['Tour.Name']}}
            </router-link>
          </td>
          <td>{{stat['Count']}}</td>

          <td v-for="pt in $root.paymentTypes">
            <router-link
                v-show="stat['PTypes'][pt.Id]['Count'] > 0"
                :to="{ name: 'debt', params: {tourId: stat['Tour.Id']}, query: {allowPaymentTypeIds: pt.Id}}">
              {{stat['PTypes'][pt.Id]['Summary']}}
            </router-link>
            </td>
          <!--                    <td>{{stat['Summary']}}</td>-->
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import { get } from '@/admin/services/api/http-utils';
import DebtByTourId from '@/admin/modules/Debt/_components/DebtByTourId';

const url = `${process.env.VUE_APP_API_HOST}admin/debt`;

export default {
  components: {
    DebtByTourId,
  },
  data() {
    return {
      tourStats: [],
    };
  },
  computed: {
    totalOrderCount() {
      if (this.tourStats) {
        return _.sumBy(this.tourStats, o => +o.Count);
      }
      return 0;
    },

  },
  async mounted() {
    await this.fetchTourStats();
  },
  methods: {
    async fetchTourStats() {
      const { data } = await get(`${url}/tour-stats`);
      this.tourStats = data;
    },
    totalSummaryByPtId(ptId) {
      return _.sumBy(this.tourStats, o => {
        return +o.PTypes[ptId].Summary || 0;
      });
    },
  },
};
</script>
